export enum GoogleOAuthScope {
    GmailSend = "https://www.googleapis.com/auth/gmail.send",
    CalendarReadOnly = "https://www.googleapis.com/auth/calendar.readonly",
    CalendarEvents = "https://www.googleapis.com/auth/calendar.events"
}